import React, { useState } from 'react'
import RollerLoading from '../RollerLoading'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const DeleteInvoiceButton = ({ id, setSoftlandOrder }) => {

    const [isDeleting, setIsDeleting] = useState(false)

    const removeInvoice = () => {
        Swal.fire({
            title: 'Borrar Folio',
            text: '¿Estas seguro/a de eliminar el folio?, esta acción es irreversible.',
            confirmButtonText: 'Eliminar Folio',
            confirmButtonColor: '#ff0000',
            showCancelButton: true

        }).then(response => {
            if (response.isConfirmed) {
                deleteInvoice()
            }
        })
    }

    const deleteInvoice = () => {
        if (!isDeleting) {
            setIsDeleting(true)
            axios.get(`/delete-DTE/${id}`)
                .then(response => {
                    setTimeout(() => {
                        setIsDeleting(false)
                        if (response.data.status === 'success') {
                            toast.success('Registro borrado')
                            setSoftlandOrder(null)
                        }
                    }, 800)
                }).catch(error => {
                    console.error('Error en Delete DTE: ', error)
                    setIsDeleting(false)
                    setIsInvoiceRequested(false)
                })
        }
    }
    return (
        <>
            {
                isDeleting ?
                    <RollerLoading />
                    :
                    <div className="rounded-full p-1 ml-3 w-6 h-6 bg-red-600 flex items-center justify-center cursor-pointer"
                        onClick={() => {
                            removeInvoice()
                        }}
                    >
                        <p className="text-white text-lg font-bold">&times;</p>
                    </div>
            }
        </>
    )
}

export default DeleteInvoiceButton